import { render, staticRenderFns } from "./AddTranslation.vue?vue&type=template&id=66bad868&scoped=true"
import script from "./AddTranslation.vue?vue&type=script&lang=js"
export * from "./AddTranslation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bad868",
  null
  
)

export default component.exports